// extracted by mini-css-extract-plugin
export default {"main":"main_main__sW8h1"};